import { gql } from '@/utilities/gql';
import type { VariablesOf } from '@/utilities/gql';
import { gqlClient } from '@/utilities/graphQLClient';

import {
  WATCHLIST_ITEM_FRAGMENT,
  WATCHLIST_NARRATIVE_FAIR_VALUE_FRAGMENT,
} from '@/hooks/useWatchlist';

const QUERY = gql(
  `
    mutation addWatchlistItem(
      $id: String!
      $watchlistId: String!
      $autoAdded: Boolean
    ) {
      addWatchlistItem(
        id: $id
        watchlistId: $watchlistId
        autoAdded: $autoAdded
      ) {
        ...watchlistItemFields
        ...narrativeFairValueFields
      }
    }
  `,
  [WATCHLIST_ITEM_FRAGMENT, WATCHLIST_NARRATIVE_FAIR_VALUE_FRAGMENT]
);

type Args = VariablesOf<typeof QUERY>;

// TODO: This needs refactoring. We shouldn't be appending these values to the query args
// However, the legacy logic piggybacks these values in so they can used within the queryFn mutation success
type OverScopedValues = {
  includeSnackBar?: boolean;
};

export const addQueryFn = async ({
  id,
  watchlistId,
  autoAdded,
}: Args & OverScopedValues) => {
  const response = await gqlClient.request(QUERY, {
    id,
    watchlistId,
    autoAdded,
  });

  const { addWatchlistItem } = response;

  return addWatchlistItem;
};
